/* eslint-disable no-console */

import { setSyncDebugEnabled } from './syncDebug';

export const DEBUG_LEVELS = ['log', 'error', 'warn', 'info', 'debug'] as const;
export type DebugLevel = typeof DEBUG_LEVELS[number];
// @ts-ignore
const ORIGINAL_FUNCTIONS: Record<DebugLevel, (...args: any[]) => void> = DEBUG_LEVELS.reduce((acc, level) => {
  // @ts-ignore
  acc[level] = console[level];
  return acc;
}, {});

type DebugEntry = {
  level: DebugLevel;
  args: any[];
  date: Date;
};
let DEBUG_LOGS: DebugEntry[] = [];
const MAX_DEBUG_LOGS = 5000;
let isEnabled = false;

export function logDebugMessage(level: DebugLevel, ...args: any[]) {
  if (!isEnabled) return;
  if (DEBUG_LOGS.length >= MAX_DEBUG_LOGS) {
    DEBUG_LOGS.splice(0, 500);
  }
  DEBUG_LOGS.push({
    level,
    args,
    date: new Date(),
  });
  ORIGINAL_FUNCTIONS[level](...args);
}

export function initDebugConsole() {
  if (isEnabled) return;
  isEnabled = true;
  DEBUG_LOGS = [];
  DEBUG_LEVELS.forEach((level) => {
    // @ts-ignore
    console[level] = (...args: any[]) => {
      logDebugMessage(level, ...args);
    };
  });
  setSyncDebugEnabled(true);
}

export function disableDebugConsole() {
  isEnabled = false;
  setSyncDebugEnabled(false);
  DEBUG_LEVELS.forEach((level) => {
    // @ts-ignore
    console[level] = ORIGINAL_FUNCTIONS[level];
  });
  DEBUG_LOGS = [];
}

export function getDebugLogs() {
  return JSON.stringify(DEBUG_LOGS, (key, value) => (typeof value === 'bigint'
    ? value.toString()
    : value));
}
